import React from 'react';
import CrmInteractionsListPage from './components/CrmInteractionsListPage';

export default function InteractionsPage() {
  return <CrmInteractionsListPage pageKey="interactionsPage" showDealAmount />;
}
